import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Img, Text, Input, AutoFillAddress } from "components";
import { DeleteModal } from "popups/DeleteModal";
import globalRequest from "../../../../utils/global/globalRequest";
import { useDispatch, useSelector } from "react-redux";
import { changeLoader } from "../../../../redux/reducers/loader";
import { updateMyAddress, getAddressData } from "../../../../redux/reducers/myAddress";
import { USERS, GUEST, ADDRESS } from "../../../../utils/helper/Enum";
import { setSnackbar } from "../../../../redux/reducers/snackbar";
import EmptyAllTab from "../EmptyAllTab";
import { currentTrigger, changeTrigger } from "redux/reducers/trigger";
import {
  buildFullAddress,
  defaultAddressParams,
  validateForm,
  strFormat,
  isValidMobile,
} from "../../../../utils/helper/custom";
import * as CUSTOM from "../../../../utils/helper/custom";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../../../utils/global/localData";
import { getAuth } from "../../../../redux/reducers/loginData";
import { useAppFont } from "utils/helper/useAppFont";

const MyAddresses = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const triggerValue = useSelector(currentTrigger);
  const auth = useSelector(getAuth);
  const getAddress = useSelector(getAddressData);
  const [apiLoadStatus, setApiLoadStatus] = useState(true);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [deleteId, setDeleteId] = React.useState(0);
  const setEditData = React.useState(null)[1];
  const [deleteConfirm, setdeleteConfirm] = useState("");
  const [openMenuId, setOpenMenuId] = useState(null);
  const [errors, setErrors] = useState({});
  const [apiData, setApiData] = React.useState({
    allAddress: [],
    allData: null,
  });
  const { interClass, headingClass, headingFamily} = useAppFont();

  /**
   * Edit add address form open (inline mode)
   */
  const handelsetAddEditAddressOpen = (id) => {
    let defaultAddress = defaultAddressParams();

    if (id > 0) {
      const updatedAllAddress = apiData.allAddress.filter(
        (item) => item.id == id
      );
      setEditData(updatedAllAddress[0]);
      defaultAddress = defaultAddressParams(updatedAllAddress[0]);
    } else {
      setEditData(null);
    }
    dispatch(updateMyAddress(defaultAddress));
    setShowAddressForm(true);
    setOpenMenuId(null);
  };

  const [DeleteModalOpen, setDeleteModalOpen] = React.useState(false);
  const handelsetDeleteModalOpen = (id) => {
    setDeleteId(id);
    setDeleteModalOpen(true);
    setOpenMenuId(null);
  };

  /**
   * Close address form and go back to list
   */
  const closeAddressForm = () => {
    setShowAddressForm(false);
    setErrors({});
  };

  /**
   * Save Address
   */
  const saveAddress = async (e) => {
    e.preventDefault();
    let validationErrors = validateForm(getAddress, "addAddress", t, auth?.id);
    let validateMobile = isValidMobile(getAddress?.mobile_no, t);
    validationErrors = { ...validationErrors, ...validateMobile };
    if (!getAddress?.addressDetails || getAddress.addressDetails.trim() === "") {
      validationErrors = {
        ...validationErrors,
        addressDetails: t("pleaseEnterAddressLabel") || "Please enter address label",
      };
    }
    setErrors(validationErrors);
    
    if (Object.keys(validationErrors).length === 0) {
      dispatch(changeLoader(true));
      if (auth?.id) {
        try {
          let response = await globalRequest(
            Number(getAddress?.id) < 1
              ? USERS?.ADD_ADDRESS
              : USERS?.UPDATE_ADDRESS,
            Number(getAddress?.id) < 1 ? "post" : "put",
            {
              ...getAddress,
              address: getAddress?.street_address || "",
              address_details: getAddress?.addressDetails || "",
            },
            {},
            true
          );
          response = response?.data;
          dispatch(changeLoader(false));
          if (response?.status !== "SUCCESS") {
            dispatch(
              setSnackbar({
                snackbarOpen: true,
                snackbarMessage: response?.message,
                snackbarState: "error",
              })
            );
            return;
          }
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: response?.message,
              snackbarState: "success",
            })
          );
          getAlladdress();
          setShowAddressForm(false);
        } catch (e) {
          dispatch(changeLoader(false));
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: e?.message,
              snackbarState: "error",
            })
          );
        }
      } else {
        let addguest = {
          ...getAddress,
          address: getAddress?.street_address || "",
          address_details: getAddress?.address || "",
        };
        addguest.guest_id = CUSTOM.getDeviceID();
        try {
          let response = await globalRequest(
            ADDRESS.CHECK_ADDRESS,
            "post",
            addguest,
            {},
            true
          );
          response = response?.data;
          dispatch(changeLoader(false));
          if (response?.status !== "SUCCESS") {
            dispatch(
              setSnackbar({
                snackbarOpen: true,
                snackbarMessage: response?.message,
                snackbarState: "error",
              })
            );
            return;
          }
          addDeleteGetLocalStorage(
            storageKeys.GUEST_ADDRESS,
            {
              ...getAddress,
              address: getAddress?.street_address || "",
              address_details: getAddress?.address || "",
            },
            "add",
            "single"
          );
          getAlladdress();
          setShowAddressForm(false);
        } catch (e) {
          dispatch(changeLoader(false));
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: e?.message,
              snackbarState: "error",
            })
          );
        }
      }
    }
  };

  /**
   * get address from api
   */
  const getAlladdress = async () => {
    try {
      dispatch(changeLoader(true));
      let response = await globalRequest(
        USERS?.GET_ALL_ADDRESS,
        "get",
        {},
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        let address =
          response?.data?.userAddresses != null
            ? response?.data?.userAddresses
            : [];
        setApiData({
          ...apiData,
          allAddress: address,
          allData: response?.data,
        });
      }
    } catch (e) {
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
    dispatch(changeLoader(false));
    setApiLoadStatus(false);
  };

  /**
   * remove id from state
   */
  const removeIdFromAddressList = (id) => {
    const updatedAllAddress = apiData.allAddress.filter(
      (item) => item.id !== id
    );
    setApiData((prevState) => ({
      ...prevState,
      allAddress: updatedAllAddress,
    }));
  };

  /**
   * delete address
   */
  const deleteAddress = async () => {
    try {
      dispatch(changeLoader(true));
      let response = await globalRequest(
        USERS?.DELETE_ADDRESS + "/" + deleteId,
        "delete",
        { id: deleteId },
        {},
        true
      );
      response = response?.data;
      dispatch(changeLoader(false));
      if (response?.status == "SUCCESS") {
        setDeleteId(0);
        setDeleteModalOpen(false);
        setdeleteConfirm("");
        removeIdFromAddressList(deleteId);
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: response?.message,
            snackbarState: "success",
          })
        );
        return false;
      }
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: response?.message,
          snackbarState: "error",
        })
      );
    } catch (e) {
      dispatch(changeLoader(false));
      dispatch(
        setSnackbar({
          snackbarOpen: true,
          snackbarMessage: e?.message,
          snackbarState: "error",
        })
      );
    }
  };

  /**
   * Toggle three dot menu
   */
  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
  };

  /**
   * Close menu when clicking outside
   */
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openMenuId && !event.target.closest('.three-dot-menu-container')) {
        setOpenMenuId(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openMenuId]);

  /**
   * delete confirm
   */
  useEffect(() => {
    if (triggerValue == "loadAddressList") {
      getAlladdress();
      setShowAddressForm(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerValue]);

  useEffect(() => {
    setApiLoadStatus(true);
    getAlladdress();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (deleteConfirm) {
      if (deleteConfirm == "no") {
        setDeleteId(0);
        setDeleteModalOpen(false);
        setdeleteConfirm("");
      } else {
        deleteAddress();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteConfirm]);

  // If showing address form, render the form view
  if (showAddressForm) {
    return (
      <>
        <div className="w-full">
          {/* Header */}
          <div className="flex items-center justify-between w-full mb-6">
            <Text className={`text-[20px] font-semibold text-black-900 ${interClass}`}>
              {t("Addresses")}
            </Text>
          </div>

          {/* Search Input */}
          <div className="w-full mb-6">
            <div className="relative">
              <Img
                src="/images/img_search.svg"
                className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400"
                alt="search"
              />
              <input
                type="text"
                placeholder="Search for Location"
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:border-gray-400"
              />
            </div>
          </div>

          {/* Map */}
          <div className="flex flex-row w-full sm:flex-col">
          <div className="w-full mb-6 rounded-xl overflow-hidden h-auto p-[2%] rounded-20">
            <AutoFillAddress></AutoFillAddress>
          </div>

          {/* Address Form */}
          <form id="addressForm" className="w-full p-[2%]" onSubmit={saveAddress}>
            {(getAddress?.location_skipped ||
              (getAddress?.current_location_distance !== undefined &&
                getAddress?.current_location_distance !== null)) && (
              <div className="w-full mb-2">
                <Text className={`text-[13px] font-normal text-[#6D737E] ${interClass}`}>
                  {getAddress?.location_skipped
                    ? (t("yourCurrentLocationIsOff"))
                    : getAddress.current_location_distance < 1
                    ? `${Math.round(getAddress.current_location_distance * 1000)} m from your current location`
                    : `${getAddress.current_location_distance.toFixed(2)} km from your current location`}
                </Text>
              </div>
            )}
            {/* Address Label */}
            <div className="w-full">
              <label className={`block mb-2 text-[14px] font-medium text-[#6D737E] ${interClass}`}>
                {t("addressLabel")}*
              </label>
              <Input
                className={`w-full ${interClass} placeholder:text-[12px]`}
                placeholder={t("addressPlaceholder")}
                error={errors?.addressDetails}
                value={getAddress?.addressDetails || ""}
                onChange={(e) => {
                  setErrors({ ...errors, addressDetails: "" });
                  dispatch(
                    updateMyAddress({
                      ...getAddress,
                      addressDetails: strFormat(e.target.value, "max:100"),
                    })
                  );
                }}
              />
            </div>

            {/* Street Address */}
            <div className="w-full">
              <label className={`block mb-2 text-[14px] font-medium text-gray-700 ${interClass}`}>
                {t("streetAddress")}*
              </label>
              <Input
                className="w-full figma-input"
                placeholder={t("enterStreetAddress")}
                error={errors?.street_address}
                value={getAddress?.street_address || ""}
                // onChange={(e) => {
                //   setErrors({ ...errors, street_address: "" });
                //   dispatch(
                //     updateMyAddress({
                //       ...getAddress,
                //       street_address: strFormat(e.target.value, "max:100"),
                //     })
                //   );
                // }}
                readOnly
                // disabled={true}
              />
            </div>

            {/* Street Number */}
            <div className="w-full">
              <label className={`block mb-2 text-[14px] font-medium text-gray-700 ${interClass}`}>
                {t("streetNumber")}*
              </label>
              <Input
                className="w-full figma-input"
                placeholder={t("enterStreetNumber")}
                error={errors?.street_number}
                value={getAddress?.street_number || ""}
                onChange={(e) => {
                  setErrors({ ...errors, street_number: "" });
                  dispatch(
                    updateMyAddress({
                      ...getAddress,
                      street_number: strFormat(e.target.value, "max:50"),
                    })
                  );
                }}
              />
            </div>

            {/* Building Number */}
            <div className="w-full">
              <label className={`block mb-2 text-[14px] font-medium text-gray-700 ${interClass}`}>
                {t("buildingNumber")}*
              </label>
              <Input
                className="w-full figma-input"
                placeholder={t("enterBuildingNumber")}
                error={errors?.building_number}
                value={getAddress?.building_number || ""}
                onChange={(e) => {
                  setErrors({ ...errors, building_number: "" });
                  dispatch(
                    updateMyAddress({
                      ...getAddress,
                      building_number: strFormat(e.target.value, "max:50"),
                    })
                  );
                }}
              />
            </div>

            {/* Floor/Apartment Number */}
            <div className="w-full">
              <label className={`block mb-2 text-[14px] font-medium text-gray-700 ${interClass}`}>
                {t("floor_Apartment")}
              </label>
              <Input
                className="w-full figma-input"
                placeholder={t("enterFloorNumber")}
                error={errors?.floor_apartment}
                value={getAddress?.floor_apartment || ""}
                onChange={(e) => {
                  setErrors({ ...errors, floor_apartment: "" });
                  dispatch(
                    updateMyAddress({
                      ...getAddress,
                      floor_apartment: strFormat(e.target.value, "max:50"),
                    })
                  );
                }}
              />
            </div>
          </form>
          
          </div>
          {/* Save Button */}
            <div className="w-full flex flex-row gap-3 sm:flex-col">
              <Button
                className={`w-full h-[50px] rounded-full border border-[#7A2C4E] bg-white hover:bg-gray-50 text-[#7A2C4E] text-[16px] font-medium ${headingClass} sm:text-[14px]`}
                size="lg"
                variant="OutlineBlack"
                type="button"
                onClick={closeAddressForm}
              >
                {t("cancel")}
              </Button>
              <Button
                className={`w-full h-[50px] rounded-full bg-[#7A2C4E] hover:bg-[#8B1543] text-white text-[16px] font-medium ${headingClass} sm:text-[14px]`}
                size="lg"
                variant="FillBlack"
                type="submit"
                form="addressForm"
                disabled={!getAddress?.location_verified && !getAddress?.location_skipped}
              >
                {t("saveNewAddress")}
              </Button>
            </div>
        </div>
      </>
    );
  }

  // Otherwise, render the address list view
  return (
    <>
      <div className="flex flex-row font-nunitomedium items-center justify-between w-full mb-7">
        <Text
          className={`text-2xl md:text-[22px] text-black-900 sm:text-xl font-semibold ${interClass}`}
        >
          {t("myAddresses")}
        </Text>
        {apiData?.allAddress.length > 0 ? (
          <Button
            className="min-w-[125px] flex items-center justify-center rounded-full"
            size="md"
            variant="OutlineBlack"
            hover={true}
            hoverclass="bg-pink-300"
            onClick={(e) => {
              handelsetAddEditAddressOpen(0);
            }}
          >
            <Text
              as="span"
              className="mx-2 text-center text-[14px] font-medium leading-[20px] text-[#1A1A1A]"
              style={{ fontFamily: headingFamily }}
            >
              {t("newAddress")}
            </Text>
          </Button>
        ) : null}
      </div>
      {apiData?.allAddress.map((item, index) => {
        return (
          <div
            key={"address-key-" + index}
            className="flex items-start justify-between p-5 bg-white border border-gray-200 rounded-lg mb-4 hover:shadow-sm transition-shadow"
          >
            <div className="flex-1">
              <Text
                className={`text-black-900 text-base font-semibold mb-2 ${interClass}`}
              >
                {/* {item?.fullName} */}
                {item?.addressDetails || "Address name"}
              </Text>
              <Text
                className={`text-gray-600 text-sm leading-relaxed ${interClass}`}
              >
                {buildFullAddress(item)}
              </Text>
            </div>
            <div className="relative three-dot-menu-container ml-4">
              <button
                onClick={() => toggleMenu(item?.id)}
                className="cursor-pointer p-2 border border-[#E6E6E6] hover:bg-gray-100 rounded-full transition-colors"
              >
                <Img
                  src="/images/threeDot.svg"
                  className="w-4 h-4"
                  alt="edit"
                />
              </button>
              {openMenuId === item?.id && (
                <div className={`absolute right-0 mt-2 w-40 bg-[white] border border-gray-200 rounded-lg shadow-lg z-50 ${interClass}`}>
                  <button
                    onClick={() => handelsetAddEditAddressOpen(item?.id)}
                    className="w-full px-4 py-3 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-3 border-b border-gray-100"
                  >
                    <Img
                      src="/images/img_edit_black_900.svg"
                      className="w-4 h-4"
                      alt="edit"
                    />
                    <span className={`${interClass}`}>{t("edit")}</span>
                  </button>
                  <button
                    onClick={() => handelsetDeleteModalOpen(item?.id)}
                    className="w-full px-4 py-3 text-left text-sm text-red-600 hover:bg-gray-50 flex items-center gap-3"
                  >
                    <Img
                      src="/images/img_trash.svg"
                      className="w-4 h-4"
                      alt="delete"
                    />
                    <span className={`${interClass}`}>{t("delete")}</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        );
      })}
      {apiData?.allAddress.length == 0 && !apiLoadStatus ? (
        <>
          <EmptyAllTab
            emptyImg="images/empty-location-icon.svg"
            emptyParagraph="Add addresses here to use it in future while placing an order"
            emptyBtn="New Address"
            addAddressTrigger={handelsetAddEditAddressOpen}
          />
        </>
      ) : null}
      {/* Removed popup - using inline form instead
      {AddEditAddressOpen === true ? (
        <AddEditAddress
          setAddAddressPopup={setAddEditAddressOpen}
          pageName={"myAddress"}
        />
      ) : null}
      */}
      {DeleteModalOpen === true ? (
        <DeleteModal
          deleteTitle={t("deleteAddress")}
          deleteParagraph={t(
            "areYouSureYouWantToDeleteThisAddressQuestionMark"
          )}
          closepopup={setDeleteModalOpen}
          deleteConfirm={setdeleteConfirm}
        />
      ) : null}
    </>
  );
};

export default MyAddresses;
